import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import SearchSmallIcon from 'components/common/IconsV2/SearchSmallIcon';
import { FEATURE_SEARCH_FACETS_UPDATE } from 'constants/features';
import { useIsEnrolledInVariant } from 'hooks/unleash/useIsEnrolledInVariant';
import { clearAutoComplete, unRegisterAutoComplete, updateAutoComplete } from 'actions/autoComplete';
import useMartyContext from 'hooks/useMartyContext';
import { Input } from 'components/common/Input';

import css from 'styles/components/common/autoComplete.scss';

export const AutoComplete = ({ autoComplete, clearAutoComplete, id, title, values, handler, updateAutoComplete, onChange }) => {
  const { isEnrolled: isSearchFacetUpdate } = useIsEnrolledInVariant(FEATURE_SEARCH_FACETS_UPDATE);
  const { testId } = useMartyContext();
  const inputRef = useRef();

  useEffect(() => {
    clearAutoComplete(id);

    return () => {
      unRegisterAutoComplete(id);
    };
  }, [id, clearAutoComplete]);

  useEffect(() => {
    const autoCompleteValues = autoComplete[id]?.values;
    const currentValue = inputRef.current.value;
    if (!autoCompleteValues && currentValue) {
      inputRef.current.value = '';
    }
  }, [autoComplete, id]);

  const filterVal = searchText => {
    const matchedValues = values.filter(v => handler(v, searchText));
    updateAutoComplete(id, searchText, matchedValues);
  };

  const handleFilterChange = e => {
    filterVal(e.target.value);
    onChange?.(e);
  };

  const submit = e => {
    e.preventDefault();
  };

  if (isSearchFacetUpdate) {
    return (
      <form method="post" className="relative text-gray-400 focus-within:text-gray-700" onSubmit={submit} role="search" aria-label={title}>
        <SearchSmallIcon size={16} className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2" />

        <Input
          type="text"
          id={title}
          data-test-id={testId(`autoComplete-${title}`)}
          ref={inputRef}
          autoComplete="off"
          className="body-m w-full rounded border border-gray-300 py-2 pl-10 pr-4 transition-colors placeholder:text-gray-400 focus-visible:border-gray-700 zappos:outline-none"
          placeholder="Search"
          onChange={handleFilterChange}
        />

        <label htmlFor={title} className="sr-only">
          Narrow Your {title} choices
        </label>
      </form>
    );
  }

  return (
    <form method="post" className={css.autoComplete} onSubmit={submit} role="search" aria-label={title}>
      <Input
        type="text"
        id={title}
        data-test-id={testId(`autoComplete-${title}`)}
        ref={inputRef}
        placeholder={`Search ${title}`}
        onChange={handleFilterChange}
      />
      <label htmlFor={title} className="sr-only">
        Narrow Your {title} choices
      </label>
    </form>
  );
};

function mapStateToProps({ autoComplete }) {
  return {
    autoComplete
  };
}

export default connect(mapStateToProps, {
  clearAutoComplete,
  unRegisterAutoComplete,
  updateAutoComplete
})(AutoComplete);
